import { mapMutations } from "vuex";

export default {
  methods: {
    initScrollView() {
      this.$nextTick(() => {
        //设置容器宽度
        this.$refs.block__container.style.width =
          this.cardWidth * this.days.length + "px";

        //初始化滚动位置
        this.initScroll();

        //检测窗口大小变化
        window.addEventListener("resize", this.handleResize);
      });
    },
    initScroll() {
      this.$refs.scroll__container.scrollTo(
        this.getPixel(this.visibleDays[0]),
        this.$refs.scroll__container.scrollTop
      );
    },
    handleScroll(event) {
      const { scrollLeft, clientWidth } = event.target;
      this.updatedVisibleDays({ scrollLeft, clientWidth });
    },
    handleResize() {
      if (!this.$refs.scroll__container) return;
      const { scrollLeft, clientWidth } = this.$refs.scroll__container;
      this.$nextTick(() => {
        this.updatedVisibleDays({ scrollLeft, clientWidth });
      });
    },
    horizontalScroll(event) {
      // 计算鼠标滚轮滚动的距离
      const direction = -event.wheelDelta / 120;
      this.$refs.scroll__container.scrollLeft += direction * 50;
    },
    getPixel(day) {
      const pixel =
        ((day - this.originDate) / (24 * 60 * 60 * 1000)) * this.cardWidth;
      return pixel;
    },
    ...mapMutations(["updatedVisibleDays"])
  }
};
